import * as THREE from "three";

/**
 * Тень касания под стопами (Джон 04.11.2026, 22:50: «что с стопами? Он же не стоит на земле»): тень от ключевого света
 * падает вбок, и стопа без тёмного пятна под собой кажется висящей. Мягкое пятно под носком и пяткой каждой ноги —
 * темнее, чем ближе стопа к полу; в воздухе гаснет.
 */
const BONES = ["mixamorigLeftToeBase", "mixamorigRightToeBase", "mixamorigLeftFoot", "mixamorigRightFoot"] as const;
/** Размер пятна (пиксели мира) и высота стопы, на которой пятно гаснет совсем. */
const SIZE = 26;
const FADE_HEIGHT = 30;
const OPACITY = 0.6;

function blobTexture(): THREE.CanvasTexture {
  const canvas = document.createElement("canvas");
  canvas.width = 64;
  canvas.height = 64;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas 2D недоступен");
  const gradient = context.createRadialGradient(32, 32, 0, 32, 32, 32);
  gradient.addColorStop(0, "rgba(0,0,0,1)");
  gradient.addColorStop(0.5, "rgba(0,0,0,0.55)");
  gradient.addColorStop(1, "rgba(0,0,0,0)");
  context.fillStyle = gradient;
  context.fillRect(0, 0, 64, 64);
  return new THREE.CanvasTexture(canvas);
}

export class ContactShadows {
  private readonly blobs: THREE.Mesh<THREE.PlaneGeometry, THREE.MeshBasicMaterial>[] = [];
  private readonly point = new THREE.Vector3();

  constructor(scene: THREE.Scene) {
    const geometry = new THREE.PlaneGeometry(SIZE, SIZE * 0.6);
    const texture = blobTexture();
    for (let index = 0; index < BONES.length; index++) {
      const blob = new THREE.Mesh(
        geometry,
        new THREE.MeshBasicMaterial({ map: texture, color: 0x000000, transparent: true, depthWrite: false }),
      );
      blob.rotation.x = -Math.PI / 2;
      blob.renderOrder = 1;
      scene.add(blob);
      this.blobs.push(blob);
    }
  }

  /** Пятна под стопами модели root на этот кадр; hidden — боец скрыт (скачок). */
  update(root: THREE.Object3D, hidden: boolean): void {
    BONES.forEach((name, index) => {
      const blob = this.blobs[index];
      if (!blob) return;
      const bone = root.getObjectByName(name);
      if (!bone || hidden) {
        blob.visible = false;
        return;
      }
      bone.getWorldPosition(this.point);
      const near = 1 - Math.min(1, Math.max(0, this.point.y) / FADE_HEIGHT);
      blob.visible = near > 0;
      blob.material.opacity = OPACITY * near * near;
      blob.position.set(this.point.x, 0.5, this.point.z);
    });
  }
}
